var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproveedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43563"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 2342",
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#00A900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M39.3512 22.5431C37.4868 22.5431 35.9693 21.0267 35.9693 19.1612V13H21.6301C19.7486 13 18.2236 14.5249 18.2236 16.4065V33.8152C18.5569 33.7721 18.8951 33.7426 19.2394 33.7426C23.6248 33.7426 27.1924 37.3102 27.1924 41.6956C27.1924 42.7839 26.9723 43.8206 26.575 44.7651H42.0936C43.9751 44.7651 45.5001 43.2402 45.5001 41.3709V22.5431H39.3512ZM31.8618 24.4418C33.7163 24.4418 35.2204 25.9459 35.2204 27.8004C35.2204 29.6549 33.7163 31.1589 31.8618 31.1589C30.0073 31.1589 28.5033 29.6549 28.5033 27.8004C28.5033 25.9459 30.0073 24.4418 31.8618 24.4418ZM36.5608 35.4545C36.5608 35.8554 36.2804 36.1997 35.8869 36.2747C34.7654 36.49 33.4052 36.656 31.8618 36.656C30.3185 36.656 28.9583 36.4887 27.8368 36.2747C27.4433 36.1997 27.1629 35.8542 27.1629 35.4545V34.9171C27.1629 33.8115 27.6499 32.8264 28.4099 32.139C29.3617 32.899 30.5521 33.3725 31.8631 33.3725C33.174 33.3725 34.3632 32.899 35.3163 32.139C36.0763 32.8264 36.5633 33.8115 36.5633 34.9171V35.4545H36.5608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.2394 35.9561C16.0702 35.9561 13.5 38.5251 13.5 41.6954C13.5 44.8658 16.0702 47.4336 19.2394 47.4336C22.4085 47.4336 24.9787 44.8646 24.9787 41.6942C24.9787 38.5238 22.4097 35.9561 19.2394 35.9561ZM21.8858 41.5798L19.0844 43.8365C18.8864 43.9963 18.6417 44.0812 18.3908 44.0812C18.349 44.0812 18.3072 44.0787 18.2642 44.0738C17.9702 44.0406 17.7009 43.8906 17.5189 43.6569L16.4183 42.2525C16.0407 41.7717 16.1256 41.0756 16.6064 40.6981C17.0885 40.3218 17.7845 40.4054 18.1609 40.8862L18.5691 41.4077L20.4974 39.8544C20.9733 39.4708 21.6706 39.547 22.0531 40.0217C22.4368 40.4988 22.3618 41.1961 21.8858 41.5798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M38.1836 19.1612C38.1836 19.8056 38.7075 20.3295 39.3519 20.3295H45.5008V20.0712C45.5008 19.1612 45.1441 18.3003 44.5046 17.6609L40.8399 13.9961C40.2004 13.3566 39.3396 13 38.4295 13H38.1836V19.1612Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveedIcon);
export default __webpack_public_path__ + "static/media/approveedIcon.841bc9729e7cb45aca9fc6ad6c25acb7.svg";
export { ForwardRef as ReactComponent };